/* eslint-disable eol-last */

import request from '@/utils/home/orgin'
export function findByParentCode(query) { // 获取省市区下拉
  return request({
    url: '/api/org/addressareas/findByParentCode',
    method: 'get',
    params: query
  })
}
// tree接口
export function listtree() { // 树一次张开一层
  return request({
    url: '/api/org/enterprisedepart/listtree',
    method: 'get'
  })
}
export function departtree(query) { // 树一次全部张开
  return request({
    url: '/api/org/enterprisedepart/tree',
    method: 'get',
    params: query
  })
}
export function list(query) {
  return request({
    url: '/api/org/enterprisedepart/list',
    method: 'get',
    params: query
  })
}
export function sectionadd(data) {
  return request({
    url: '/api/org/enterprisedepart/add',
    method: 'post',
    data
  })
}
export function sectionup(data) {
  return request({
    url: '/api/org/enterprisedepart/update',
    method: 'post',
    data
  })
}
export function sectiondelete(data) {
  return request({
    url: '/api/org/enterprisedepart/delete',
    method: 'post',
    data
  })
}
// staffedit界面接口(添加员工)
export function employeesadd(data) {
  return request({
    url: '/api/org/employees/add',
    method: 'post',
    data
  })
}
export function accountstatus() {
  return request({
    url: '/api/org/dropdownlist/accountstatus',
    method: 'get'
  })
}
export function accounttype() {
  return request({
    url: '/api/org/dropdownlist/accounttype',
    method: 'get'
  })
}
export function departlist() {
  return request({
    url: '/api/org/enterprisedepart/list',
    method: 'get'
  })
}
export function roles() {
  return request({
    url: '/api/org/roles',
    method: 'get'
  })
}
export function userstatus() {
  return request({
    url: 'api/org/userstatus',
    method: 'get'
  })
}

// stafflist界面接口
export function pagelist(query) {
  return request({
    url: '/api/org/employees/pagelist',
    method: 'get',
    params: query
  })
}
export function employeesdelete(data) {
  return request({
    url: '/api/org/employees/delete',
    method: 'post',
    data
  })
}
export function employeupdate(data) {
  return request({
    url: '/api/org/employees/update',
    method: 'post',
    data
  })
}
// 修改密码
export function updatepd(data) {
  return request({
    url: 'api/org/employees/updatepassword',
    method: 'post',
    data
  })
}
export function updatepasswordself(data) {
  return request({
    url: '/api/org/employees/updatepasswordself',
    method: 'post',
    data
  })
}
export function addSendArrave(data) {
  return request({
    url: '/api/org/dealers/addSendArrave',
    method: 'post',
    data
  })
}
export function dealerupdate(data) {// 送达方详细修改
  return request({
    url: '/api/org/dealers/update',
    method: 'post',
    data
  })
}
export function modify(data) { // 送达方账号密码修改
  return request({
    url: '/api/org/dealers/modify',
    method: 'post',
    data
  })
}
export function dealerdelete(query) {
  return request({
    url: '/api/org/dealers/delete',
    method: 'get',
    params: query
  })
}
export function dealerlist(query) {
  return request({
    url: '/api/org/dealers/list',
    method: 'get',
    params: query
  })
}
export function dealerinfo(query) {// 获取送达方详情
  return request({
    url: '/api/org/dealers/dealerinfo',
    method: 'get',
    params: query
  })
}
// 角色管理 界面接口
export function rolelist(query) {
  return request({
    url: '/api/org/roles/list',
    method: 'get',
    params: query
  })
}
export function roleadd(data) {
  return request({
    url: '/api/org/roles/add',
    method: 'post',
    data
  })
}
export function rolenup(data) {
  return request({
    url: '/api/org/roles/update',
    method: 'post',
    data
  })
}
export function roledelete(data) {
  return request({
    url: '/api/org/roles/delete',
    method: 'post',
    data
  })
}
// outsource外协账号管理
export function outfactory(query) {
  return request({
    url: '/api/org/outfactory/pagelist',
    method: 'get',
    params: query
  })
}
export function outfactorydelete(data) {
  return request({
    url: '/api/org/outfactory/delete',
    method: 'post',
    data
  })
}
export function outfactoryupdate(data) {
  return request({
    url: '/api/org/outfactory/update',
    method: 'post',
    data
  })
}
export function outfactoryadd(data) {
  return request({
    url: '/api/org/outfactory/add',
    method: 'post',
    data
  })
}
// 送达方
export function sendarrival(query) {
  return request({
    url: '/api/org/sendarrival/pagelist',
    method: 'get',
    params: query
  })
}
// 包材供应商
export function packagematerialsupplier(query) {
  return request({
    url: '/api/org/packagematerialsupplier/pagelist',
    method: 'get',
    params: query
  })
}
export function supplieadd(data) {
  return request({
    url: '/api/org/packagematerialsupplier/add',
    method: 'post',
    data
  })
}
// 菜单按钮管理
export function menubuttonlist(data) {
  return request({
    url: '/api/org/menubutton/list',
    method: 'post',
    data
  })
}
export function menubuttonadd(data) {
  return request({
    url: '/api/org/menubutton/add',
    method: 'post',
    data
  })
}
export function menubuttondelete(data) {
  return request({
    url: '/api/org/menubutton/delete',
    method: 'post',
    data
  })
}
export function menubuttonupdate(data) {
  return request({
    url: '/api/org/menubutton/update',
    method: 'post',
    data
  })
}
// 获取菜单树带按钮
export function alltreebuttons(query) {
  return request({
    url: '/api/org/menutree/alltreebuttons',
    method: 'get',
    params: query
  })
}
// 获取菜单树不带按钮
export function alltree(query) {
  return request({
    url: '/api/org/menutree/alltree',
    method: 'get',
    params: query
  })
}
export function allrolestree(data) { // 获取角色所有菜单与角色已有权限菜单树
  return request({
    url: '/api/org/menutree/allrolestree',
    method: 'post',
    data
  })
}
export function savetree(data) { // 保存角色菜单树
  return request({
    url: '/api/org/menutree/savetree',
    method: 'post',
    data
  })
}
// 部门职位管理接口
export function listjob(data) {
  return request({
    url: '/api/org/positions/list',
    method: 'post',
    data
  })
}
export function addjob(data) {
  return request({
    url: '/api/org/positions/add',
    method: 'post',
    data
  })
}
export function deletejob(data) {
  return request({
    url: '/api/org/positions/delete',
    method: 'post',
    data
  })
}
export function updatejob(data) {
  return request({
    url: '/api/org/positions/update',
    method: 'post',
    data
  })
}
export function positionroleadd(data) {
  return request({
    url: '/api/org/positionrole/add',
    method: 'post',
    data
  })
}
export function positionroledelete(data) {
  return request({
    url: '/api/org/positionrole/delete',
    method: 'post',
    data
  })
}
export function positionroleupdate(data) {
  return request({
    url: '/api/org/positionrole/update',
    method: 'post',
    data
  })
}
export function positionrolelist(data) {
  return request({
    url: '/api/org/positionrole/list',
    method: 'post',
    data
  })
}
// 登录获取权限
export function getInfo(token) {
  return request({
    url: '/api/org/menutree/selectedlist',
    method: 'get',
    params: { token }
  })
}
export function setmenusenable(data) { // 设置菜单树是否可用 0不可用 1可用
  return request({
    url: '/api/org/menutree/menutreeenable',
    method: 'post',
    data
  })
}
// 根据企业编码查询备案信息 不带token
export function authgeticp(query) {
  return request({
    url: '/api/org/enterpriseaccountnoauth/geticp',
    method: 'get',
    params: query,
  })
}
// 根据企业编码查询备案信息
export function geticp(query) {
  return request({
    url: '/api/org/enterpriseaccount/geticp',
    method: 'get',
    params: query
  })
}
// 修改企业备案信息
export function updateicp(data) {
  return request({
    url: '/api/org/enterpriseaccount/updateicp',
    method: 'post',
    data
  })
}

export function dealers(data) {
  return request({
    url: '/api/org/enterprisedepart/pageList',
    method: 'get',
    params: data
  })
}